import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, Phone, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { CONTACT } from '../mock';

const LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About Us' },
  { to: '/services', label: 'Services' },
  { to: '/divisions', label: 'Divisions' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact Us' }
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 fx-glass-light border-b border-slate-200/70">
      <div className="bg-slate-900 text-slate-300">
        <div className="fx-container flex flex-wrap items-center justify-center md:justify-end gap-x-5 gap-y-1 py-1.5 text-xs">
          {CONTACT.phones.map((p) => (
            <a key={p.tel} href={`tel:${p.tel}`} data-testid={`topbar-phone-${p.tel}`} className="flex items-center gap-1.5 hover:text-emerald-400">
              <Phone size={12} className="text-emerald-400" /> {p.display}
            </a>
          ))}
          <span className="hidden md:inline text-slate-600">|</span>
          <span className="hidden md:flex items-center gap-1.5"><Clock size={12} className="text-emerald-400" /> {CONTACT.hours}</span>
        </div>
      </div>
      <div className="fx-container flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group" onClick={() => setOpen(false)} data-testid="navbar-logo-link">
          <img src="/fixed-logo.svg" alt="Fixed Group" className="h-12 w-auto transition-transform duration-300 group-hover:scale-105" />
          <div className="leading-tight">
            <div className="font-extrabold tracking-tight text-slate-900 text-lg font-display">Fixed<span className="text-emerald-600">°</span> Group</div>
            <div className="text-[11px] uppercase tracking-widest text-slate-500">Cold Chain Specialists</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `fx-link text-sm font-medium ${isActive ? 'active' : ''}`}>
              {l.label}
            </NavLink>
          ))}
          <Button asChild data-testid="navbar-contact-btn" className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full px-6 shadow-lg shadow-emerald-600/25 hover:shadow-emerald-600/40"><Link to="/contact">Request a Quote</Link></Button>
        </nav>

        <button className="lg:hidden p-2 rounded-md hover:bg-slate-100" onClick={() => setOpen(!open)} aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} aria-controls="mobile-navigation" data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div id="mobile-navigation" className="lg:hidden border-t border-slate-200 bg-white">
          <div className="fx-container py-3 flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}
                className={({ isActive }) => `px-3 py-2.5 rounded-md text-sm font-medium ${isActive ? 'bg-emerald-50 text-emerald-700' : 'text-slate-700 hover:bg-slate-50'}`}>
                {l.label}
              </NavLink>
            ))}
            <div className="px-3 py-2 flex flex-col gap-1.5 text-sm text-slate-600">
              {CONTACT.phones.map((p) => (
                <a key={p.tel} href={`tel:${p.tel}`} className="flex items-center gap-2 hover:text-emerald-700"><Phone size={14} className="text-emerald-600" /> {p.display}</a>
              ))}
            </div>
            <Link to="/contact" onClick={() => setOpen(false)} className="mt-2">
              <Button data-testid="mobile-contact-btn" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-full">Request a Quote</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
